(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Butelka-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function shopRoot(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function initGallery(sec){
    var main=sec.querySelector('[data-main] img,[data-main] svg');
    sec.querySelectorAll('[data-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var full=btn.getAttribute('data-full');
        var img=btn.querySelector('img');
        if(main&&main.tagName==='IMG'){main.src=full||(img?img.src:main.src);main.removeAttribute('srcset');}
        sec.querySelectorAll('[data-thumb]').forEach(function(b){b.classList.remove('is-active');});
        btn.classList.add('is-active');
      });
    });
  }
  function openDrawer(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer){window.location.href=shopRoot()+'cart';return;}
    try{ if(typeof drawer.open==='function'){drawer.open();} else {drawer.classList.remove('is-empty');drawer.classList.add('animate','active');document.body.classList.add('overflow-hidden');} }
    catch(e){ drawer.classList.add('animate','active');document.body.classList.add('overflow-hidden'); }
  }
  function refreshDrawer(){
    var wrap=document.getElementById('shopify-section-cart-drawer');
    return fetch(shopRoot()+'?section_id=cart-drawer',{headers:{'Accept':'text/html'}})
      .then(function(r){return r.text();})
      .then(function(html){ if(wrap){wrap.innerHTML=html;} })
      .then(function(){ return fetch(shopRoot()+'?section_id=cart-icon-bubble').then(function(r){return r.text();}).then(function(h){var b=document.getElementById('shopify-section-cart-icon-bubble');if(b){b.innerHTML=h;}}).catch(function(){}); })
      .catch(function(){});
  }
  function initAtc(form){
    if(form.dataset.buReady) return; form.dataset.buReady='1';
    var btn=form.querySelector('button[type="submit"]');
    var err=form.querySelector('[data-butelka-atc-err]');
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(err){err.hidden=true;err.textContent='';}
      if(btn){btn.classList.add('is-loading');btn.disabled=true;}
      fetch(form.getAttribute('action'),{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
        .then(function(r){return r.json().then(function(j){return {ok:r.ok,body:j};});})
        .then(function(res){ if(!res.ok){ if(err){err.hidden=false;err.textContent=(res.body&&res.body.description)||'Nie udało się dodać do koszyka.';} return; } return refreshDrawer().then(openDrawer); })
        .catch(function(){ if(err){err.hidden=false;err.textContent='Wystąpił błąd sieci. Spróbuj ponownie.';} })
        .finally(function(){ if(btn){btn.classList.remove('is-loading');btn.disabled=false;} });
    });
  }
  function boot(scope){ var s=scope||document; s.querySelectorAll('.Butelka-product').forEach(initGallery); s.querySelectorAll('[data-butelka-atc]').forEach(initAtc); }
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',function(){boot();});}
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobandi-announcement"] && !Shopify.designMode) return;
  try {
    
(function(){
  var track = document.querySelector('[data-announce-track]');
  if (!track || track.children.length < 2) return;
  var idx = 0;
  var total = track.children.length;
  setInterval(function(){
    idx = (idx + 1) % total;
    track.style.transform = 'translateX(-' + (idx * 100) + '%)';
  }, 5000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobandi-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var toggles = document.querySelectorAll('[data-bb-menu-toggle]');
  var nav = document.querySelector('[data-bb-mobile-nav]');
  var overlay = document.querySelector('.bb-header__overlay');
  if (!nav) return;
  function toggle(){
    nav.classList.toggle('is-open');
    if (overlay) overlay.classList.toggle('is-open');
    document.body.style.overflow = nav.classList.contains('is-open') ? 'hidden' : '';
  }
  toggles.forEach(function(el){ el.addEventListener('click', toggle); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobandi-hero-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* Thumbnails */
  var mainImg = document.getElementById('bb-main-img');
  var thumbs = document.querySelectorAll('[data-bb-thumb]');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      mainImg.src = t.dataset.imgSrc;
      thumbs.forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* Size pills */
  var pills = document.querySelectorAll('[data-bb-size]');
  pills.forEach(function(pill){
    pill.addEventListener('click', function(){
      pills.forEach(function(x){ x.classList.remove('is-active'); });
      pill.classList.add('is-active');
      var label = document.querySelector('[data-bb-size-label]');
      if (label) label.textContent = pill.dataset.bbSize;
      updateVariant();
    });
  });

  /* Color swatches */
  var swatches = document.querySelectorAll('[data-bb-color]');
  swatches.forEach(function(sw){
    sw.addEventListener('click', function(){
      swatches.forEach(function(x){ x.classList.remove('is-active'); });
      sw.classList.add('is-active');
      var label = document.querySelector('[data-bb-color-label]');
      if (label) label.textContent = sw.dataset.bbColor;
      updateVariant();
    });
  });

  /* Update variant */
  function updateVariant(){
    var activePill = document.querySelector('[data-bb-size].is-active');
    var activeSwatch = document.querySelector('[data-bb-color].is-active');
    if (!activePill || !activeSwatch) return;
    var size = activePill.dataset.bbSize;
    var color = activeSwatch.dataset.bbColor;
    var url = window.location.pathname + '?variant=';
    /* Use Shopify's product JSON to find variant */
    fetch(window.location.pathname + '.js')
      .then(function(r){ return r.json(); })
      .then(function(product){
        var v = product.variants.find(function(v){
          return v.options.indexOf(size) > -1 && v.options.indexOf(color) > -1;
        });
        if (v) {
          var input = document.querySelector('[data-bb-variant-id]');
          if (input) input.value = v.id;
          var priceEl = document.querySelector('[data-bb-price]');
          if (priceEl) priceEl.textContent = (v.price / 100).toFixed(2).replace('.', ',') + ' zł';
          history.replaceState(null, '', window.location.pathname + '?variant=' + v.id);
        }
      });
  }

  /* Size chart modal */
  var chart = document.querySelector('[data-bb-size-chart]');
  var chartToggles = document.querySelectorAll('[data-bb-size-chart-toggle]');
  chartToggles.forEach(function(btn){
    btn.addEventListener('click', function(){
      chart.classList.toggle('is-open');
      document.body.style.overflow = chart.classList.contains('is-open') ? 'hidden' : '';
    });
  });

  /* Size finder */
  var findBtn = document.querySelector('[data-bb-find-size]');
  if (findBtn) {
    findBtn.addEventListener('click', function(){
      var band = document.querySelector('[data-bb-band]').value;
      var cup = document.querySelector('[data-bb-cup]').value;
      var result = document.querySelector('[data-bb-size-result]');
      if (!band || !cup) {
        result.textContent = 'Proszę wybrać obwód i miseczkę.';
        result.classList.add('is-visible');
        return;
      }
      result.textContent = 'Dla obwodu ' + band + ' i miseczki ' + cup + ' polecamy rozmiar ' + cup + '. Kliknij odpowiedni rozmiar powyżej.';
      result.classList.add('is-visible');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobandi-results"] && !Shopify.designMode) return;
  try {
    
(function(){
  var findBtn = document.querySelector('[data-bb-res-find]');
  var output = document.querySelector('[data-bb-res-output]');
  if (findBtn && output) {
    findBtn.addEventListener('click', function(){
      var band = document.querySelector('[data-bb-res-band]').value;
      var cup = document.querySelector('[data-bb-res-cup]').value;
      if (!band || !cup) {
        output.textContent = 'Proszę wybrać obwód i miseczkę.';
      } else {
        output.textContent = 'Dla obwodu ' + band + ' i miseczki ' + cup + ' — Twój idealny rozmiar wkładki to: ' + cup + '. Wybierz go powyżej w sekcji produktu!';
      }
      output.classList.add('is-visible');
    });
  }

  var track = document.querySelector('.bb-results__track');
  var prev = document.querySelector('[data-bb-res-prev]');
  var next = document.querySelector('[data-bb-res-next]');
  if (track && prev && next) {
    prev.addEventListener('click', function(){ track.scrollBy({left:-300, behavior:'smooth'}); });
    next.addEventListener('click', function(){ track.scrollBy({left:300, behavior:'smooth'}); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobandi-video-tabs"] && !Shopify.designMode) return;
  try {
    
(function(){
  var btns = document.querySelectorAll('[data-bb-tab-btn]');
  var panels = document.querySelectorAll('[data-bb-tab-panel]');
  btns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var idx = btn.dataset.bbTabBtn;
      btns.forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-selected','false'); });
      panels.forEach(function(p){ p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected','true');
      var panel = document.querySelector('[data-bb-tab-panel="'+idx+'"]');
      if (panel) panel.classList.add('is-active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorandireczniki-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.cr-announcement');

  sections.forEach(function (section) {
    var track = section.querySelector('.cr-announcement__track');
    var slides = section.querySelectorAll('.cr-announcement__slide');
    if (slides.length < 2) return;

    var speed = parseInt(track.getAttribute('data-autoplay-speed'), 10) || 5;
    var current = 0;

    setInterval(function () {
      slides[current].classList.remove('cr-announcement__slide--active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('cr-announcement__slide--active');
    }, speed * 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorandireczniki-footer"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* On desktop, keep all details open */
  function handleFooterCollapsibles() {
    var collapsibles = document.querySelectorAll('.cr-footer__collapsible');
    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
    collapsibles.forEach(function(el) {
      if (isDesktop) {
        el.setAttribute('open', '');
      }
    });
  }
  handleFooterCollapsibles();
  window.addEventListener('resize', handleFooterCollapsibles);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorandireczniki-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var headers = document.querySelectorAll('.cr-header');

  headers.forEach(function (header) {
    // Drawer toggle
    var drawer = header.querySelector('[data-drawer]');
    var toggleBtns = header.querySelectorAll('[data-drawer-toggle]');
    var closeBtns = header.querySelectorAll('[data-drawer-close]');

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.add('cr-header__drawer--open');
        document.body.style.overflow = 'hidden';
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.remove('cr-header__drawer--open');
        document.body.style.overflow = '';
      });
    });

    // Sticky show/hide on scroll
    if (!header.classList.contains('cr-header--sticky-enabled')) return;

    var lastScrollY = 0;
    var ticking = false;

    function onScroll() {
      var currentScrollY = window.scrollY;

      if (currentScrollY > 60) {
        header.classList.add('cr-header--scrolled');
      } else {
        header.classList.remove('cr-header--scrolled');
      }

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        header.classList.add('cr-header--hidden');
      } else {
        header.classList.remove('cr-header--hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorandireczniki-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = '{{ section.id }}';
  var slider = document.getElementById('cr-product-slider-' + sectionId);
  var counter = document.getElementById('cr-product-counter-' + sectionId);
  var thumbsContainer = document.getElementById('cr-product-thumbs-' + sectionId);

  if (!slider) return;

  var slides = slider.querySelectorAll('.cr-product__slide');
  var totalSlides = slides.length;

  function updateCounter(index) {
    if (counter) {
      counter.textContent = (index + 1) + ' / ' + totalSlides;
    }
  }

  function updateThumbs(index) {
    if (!thumbsContainer) return;
    var thumbs = thumbsContainer.querySelectorAll('.cr-product__thumb');
    thumbs.forEach(function(thumb, i) {
      thumb.classList.toggle('cr-product__thumb--active', i === index);
    });
  }

  function scrollToSlide(index) {
    if (slides[index]) {
      slider.scrollTo({
        left: slides[index].offsetLeft,
        behavior: 'smooth'
      });
    }
  }

  /* Scroll event for counter and thumb sync */
  var scrollTimeout;
  slider.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      var scrollLeft = slider.scrollLeft;
      var slideWidth = slider.offsetWidth;
      var currentIndex = Math.round(scrollLeft / slideWidth);
      updateCounter(currentIndex);
      updateThumbs(currentIndex);
    }, 50);
  });

  /* Thumb click */
  if (thumbsContainer) {
    thumbsContainer.addEventListener('click', function(e) {
      var thumb = e.target.closest('.cr-product__thumb');
      if (thumb) {
        var index = parseInt(thumb.getAttribute('data-index'), 10);
        scrollToSlide(index);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorandireczniki-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.cr-reviews__more-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var sectionId = btn.dataset.section;
      var perPage = parseInt(btn.dataset.perPage, 10);
      var grid = document.getElementById('cr-rev-grid-' + sectionId);
      if (!grid) return;

      var hidden = grid.querySelectorAll('.cr-reviews__card--hidden');
      var count = 0;
      hidden.forEach(function(card) {
        if (count < perPage) {
          card.classList.remove('cr-reviews__card--hidden');
          count++;
        }
      });

      var remaining = grid.querySelectorAll('.cr-reviews__card--hidden');
      if (remaining.length === 0) {
        btn.style.display = 'none';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorandireczniki-video-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.cr-video-slider').forEach(function(section) {
    var sectionId = section.dataset.sectionId;
    var track = document.getElementById('cr-vs-track-' + sectionId);
    var prev = document.getElementById('cr-vs-prev-' + sectionId);
    var next = document.getElementById('cr-vs-next-' + sectionId);
    var modal = document.getElementById('cr-vs-modal-' + sectionId);
    var video = document.getElementById('cr-vs-video-' + sectionId);

    if (!track) return;

    var cards = track.querySelectorAll('.cr-video-slider__card');
    if (!cards.length) return;

    function getScrollAmount() {
      var card = cards[0];
      return card.offsetWidth + 16;
    }

    if (prev) {
      prev.addEventListener('click', function() {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function() {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    var playBtns = section.querySelectorAll('.cr-video-slider__play-btn');
    playBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var url = btn.dataset.videoUrl;
        if (url && modal && video) {
          video.src = url;
          modal.setAttribute('aria-hidden', 'false');
          video.play();
        }
      });
    });

    section.querySelectorAll('.cr-video-slider__poster').forEach(function(poster) {
      poster.addEventListener('click', function() {
        var btn = poster.querySelector('.cr-video-slider__play-btn');
        if (btn) btn.click();
      });
    });

    if (modal) {
      var overlay = modal.querySelector('.cr-video-slider__modal-overlay');
      var closeBtn = modal.querySelector('.cr-video-slider__modal-close');

      function closeModal() {
        modal.setAttribute('aria-hidden', 'true');
        if (video) {
          video.pause();
          video.src = '';
        }
      }
      if (overlay) overlay.addEventListener('click', closeModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
          closeModal();
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-announcement"] && !Shopify.designMode) return;
  try {
    
(function() {
  var tracks = document.querySelectorAll('[id^="eko-announce-track-"]');
  tracks.forEach(function(track) {
    var slides = track.querySelectorAll('.eko-announce__slide');
    if (slides.length < 2) return;
    var current = 0;
    var section = track.closest('.shopify-section');
    var speed = 4000;
    if (section) {
      var s = track.closest('.eko-announce');
      if (s) speed = (parseInt(s.dataset.speed) || 4) * 1000;
    }
    setInterval(function() {
      current = (current + 1) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }, speed);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-charity"] && !Shopify.designMode) return;
  try {
    
  /* eko-charity: no JS required */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-cta"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var buttons = document.querySelectorAll('[data-eko-cta-scroll]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-faq"] && !Shopify.designMode) return;
  try {
    
// No additional JS needed — <details>/<summary> provides native toggle behavior

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-footer"] && !Shopify.designMode) return;
  try {
    
  /* eko-footer: no JS required */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-guarantee"] && !Shopify.designMode) return;
  try {
    
// No JS needed for this section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-mission"] && !Shopify.designMode) return;
  try {
    
  /* eko-mission: no JS required */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-payments"] && !Shopify.designMode) return;
  try {
    
// No JS needed for this section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-product-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[id^="eko-product-"]').forEach(function(section) {
    var sectionId = section.id.replace('eko-product-', '');

    // Gallery slider
    var slider = document.getElementById('eko-slider-' + sectionId);
    var thumbsContainer = document.getElementById('eko-thumbs-' + sectionId);
    if (slider && thumbsContainer) {
      var thumbs = thumbsContainer.querySelectorAll('.eko-product__thumb');
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var index = parseInt(this.dataset.index);
          var slides = slider.querySelectorAll('.eko-product__slide');
          slides.forEach(function(s) { s.classList.remove('eko-product__slide--active'); });
          if (slides[index]) slides[index].classList.add('eko-product__slide--active');
          thumbs.forEach(function(t) { t.classList.remove('eko-product__thumb--active'); });
          this.classList.add('eko-product__thumb--active');
        });
      });
    }

    // Touch swipe for gallery
    if (slider) {
      var startX = 0;
      var slides = slider.querySelectorAll('.eko-product__slide');
      var currentSlide = 0;

      slider.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      slider.addEventListener('touchend', function(e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          if (diff > 0 && currentSlide < slides.length - 1) currentSlide++;
          else if (diff < 0 && currentSlide > 0) currentSlide--;
          slides.forEach(function(s) { s.classList.remove('eko-product__slide--active'); });
          slides[currentSlide].classList.add('eko-product__slide--active');
          if (thumbsContainer) {
            var thumbButtons = thumbsContainer.querySelectorAll('.eko-product__thumb');
            thumbButtons.forEach(function(t) { t.classList.remove('eko-product__thumb--active'); });
            if (thumbButtons[currentSlide]) thumbButtons[currentSlide].classList.add('eko-product__thumb--active');
          }
        }
      }, { passive: true });
    }

    // Scent + Bundle selectors
    var scents = document.getElementById('eko-scents-' + sectionId);
    var bundles = document.getElementById('eko-bundles-' + sectionId);

    function setupSelector(container, selectedClass) {
      if (!container) return;
      var labels = container.querySelectorAll('label');
      labels.forEach(function(label) {
        label.addEventListener('click', function() {
          labels.forEach(function(l) { l.classList.remove(selectedClass); });
          this.classList.add(selectedClass);
          updateVariant();
        });
      });
    }

    setupSelector(scents, 'eko-product__scent--selected');
    setupSelector(bundles, 'eko-product__bundle--selected');

    function updateVariant() {
      var variantsJson = document.getElementById('eko-variants-' + sectionId);
      if (!variantsJson) return;
      var variants = JSON.parse(variantsJson.textContent);

      var selectedScent = '';
      var selectedBundle = '';

      if (scents) {
        var checked = scents.querySelector('input:checked');
        if (checked) selectedScent = checked.value;
      }
      if (bundles) {
        var checked2 = bundles.querySelector('input:checked');
        if (checked2) selectedBundle = checked2.value;
      }

      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        if (selectedScent && v.option1 !== selectedScent) match = false;
        if (selectedBundle && v.option2 !== selectedBundle) match = false;
        if (match) {
          var idInput = document.getElementById('eko-variant-id-' + sectionId);
          if (idInput) idInput.value = v.id;

          var priceEl = document.getElementById('eko-price-' + sectionId);
          if (priceEl) priceEl.textContent = (v.price / 100).toFixed(2).replace('.', ',') + ' zł';

          var compareEl = document.getElementById('eko-compare-' + sectionId);
          if (compareEl) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              compareEl.textContent = (v.compare_at_price / 100).toFixed(2).replace('.', ',') + ' zł';
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }

          var discountEl = document.getElementById('eko-discount-' + sectionId);
          if (discountEl) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              var pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
              discountEl.textContent = pct + '%';
              discountEl.style.display = '';
            } else {
              discountEl.style.display = 'none';
            }
          }
          break;
        }
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-reasons"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initReasonsCarousel(section) {
    var viewport = section.querySelector('.eko-reasons__viewport');
    var track = section.querySelector('[data-reasons-track]');
    var slides = section.querySelectorAll('.eko-reasons__slide');
    var prevBtn = section.querySelector('[data-reasons-prev]');
    var nextBtn = section.querySelector('[data-reasons-next]');
    var progressBar = section.querySelector('[data-reasons-bar]');
    var counterCurrent = section.querySelector('[data-reasons-current]');

    if (!track || !viewport || slides.length < 2) return;

    var current = 0;
    var total = slides.length;
    var startX = 0;
    var startY = 0;
    var isDragging = false;
    var isHorizontalSwipe = null;

    function goTo(index) {
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      if (progressBar) {
        progressBar.style.width = ((current + 1) / total * 100) + '%';
      }
      if (counterCurrent) {
        counterCurrent.textContent = current + 1;
      }
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === total - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() { goTo(current - 1); });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() { goTo(current + 1); });
    }

    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
      isHorizontalSwipe = null;
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (isHorizontalSwipe === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        isHorizontalSwipe = Math.abs(dx) > Math.abs(dy);
      }

      if (isHorizontalSwipe) {
        e.preventDefault();
        var offset = -(current * viewport.offsetWidth) + dx;
        track.style.transform = 'translateX(' + offset + 'px)';
      }
    }, { passive: false });

    track.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = '';

      if (!isHorizontalSwipe) { goTo(current); return; }

      var endX = e.changedTouches[0].clientX;
      var diff = startX - endX;
      var threshold = viewport.offsetWidth * 0.2;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) goTo(current + 1);
        else goTo(current - 1);
      } else {
        goTo(current);
      }
    });

    section.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    goTo(0);
  }

  function init() {
    document.querySelectorAll('.eko-reasons').forEach(initReasonsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target.querySelector('.eko-reasons');
      if (section) initReasonsCarousel(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-reviews-widget"] && !Shopify.designMode) return;
  try {
    
/* eko-reviews-widget: no JS required */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('[id^="eko-testimonials-track-"]');
  sections.forEach(function(track) {
    var sectionId = track.id.replace('eko-testimonials-track-', '');
    var cards = track.querySelectorAll('.eko-testimonials__card');
    if (cards.length < 2) return;

    var prevBtn = document.querySelector('.eko-testimonials__arrow--prev[data-section="' + sectionId + '"]');
    var nextBtn = document.querySelector('.eko-testimonials__arrow--next[data-section="' + sectionId + '"]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        var cardWidth = cards[0].offsetWidth;
        var gap = parseInt(getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: -(cardWidth + gap), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        var cardWidth = cards[0].offsetWidth;
        var gap = parseInt(getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: cardWidth + gap, behavior: 'smooth' });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eko-trust"] && !Shopify.designMode) return;
  try {
    
// No JS needed for this section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initFaq(list){
    if(list.dataset.ksReady) return; list.dataset.ksReady='1';
    var section=list.closest('.ksiazka-faq');
    var items=Array.prototype.slice.call(list.querySelectorAll('.ksiazka-faq__item'));
    // akordeon
    items.forEach(function(it){
      var q=it.querySelector('.ksiazka-faq__q');
      q.addEventListener('click',function(){ q.setAttribute('aria-expanded', q.getAttribute('aria-expanded')==='true'?'false':'true'); });
    });
    // zakładki
    var tabsWrap=section?section.querySelector('[data-ksiazka-faq-tabs]'):null;
    if(tabsWrap){
      var tabs=Array.prototype.slice.call(tabsWrap.querySelectorAll('.ksiazka-faq__tab'));
      function count(cat){ return items.filter(function(it){ return cat==='all'||it.getAttribute('data-cat')===cat; }).length; }
      tabs.forEach(function(t){ if(count(t.getAttribute('data-cat'))===0){ t.hidden=true; } });
      var visible=tabs.filter(function(t){ return !t.hidden; });
      function activate(cat){
        tabs.forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('data-cat')===cat); });
        items.forEach(function(it){ it.hidden = !(cat==='all'||it.getAttribute('data-cat')===cat); });
        openFirst();
      }
      tabs.forEach(function(t){ t.addEventListener('click',function(){ activate(t.getAttribute('data-cat')); }); });
      var first = visible.find(function(t){ return t.classList.contains('is-active'); }) || visible[0];
      if(first){ activate(first.getAttribute('data-cat')); }
    } else { openFirst(); }
    function openFirst(){
      if(!list.hasAttribute('data-open-first')) return;
      var vis=items.filter(function(it){ return !it.hidden; });
      items.forEach(function(it){ it.querySelector('.ksiazka-faq__q').setAttribute('aria-expanded','false'); });
      if(vis[0]){ vis[0].querySelector('.ksiazka-faq__q').setAttribute('aria-expanded','true'); }
    }
  }
  function initAll(scope){ (scope||document).querySelectorAll('[data-ksiazka-faq]').forEach(initFaq); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-opinie-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  function perView(){ var w=window.innerWidth; if(w>=1080)return 3; if(w>=760)return 2; return 1; }
  function initOS(el){
    if(el.dataset.ksReady) return; el.dataset.ksReady='1';
    var track=el.querySelector('[data-ks-track]');
    var slides=track?track.children:[];
    var n=slides.length; if(!n)return;
    var prev=el.parentElement.querySelector('[data-ks-prev]')||document.querySelector('[data-ks-prev]');
    var next=el.parentElement.querySelector('[data-ks-next]')||document.querySelector('[data-ks-next]');
    var section=el.closest('.ksiazka-os');
    if(section){ prev=section.querySelector('[data-ks-prev]'); next=section.querySelector('[data-ks-next]'); }
    var dotsWrap=el.querySelector('[data-ks-dots]');
    var i=0, pv=perView(), pages=Math.max(1, n-pv+1), dots=[];
    function buildDots(){
      if(!dotsWrap)return; dotsWrap.innerHTML=''; dots=[];
      var count=Math.max(1, n-pv+1);
      for(var k=0;k<count;k++){(function(k){
        var b=document.createElement('button'); b.className='ksiazka-os__dot'+(k===0?' is-active':'');
        b.setAttribute('aria-label','Opinia '+(k+1)); b.addEventListener('click',function(){ go(k); });
        dotsWrap.appendChild(b); dots.push(b);
      })(k);}
    }
    function go(x){
      pv=perView(); pages=Math.max(1,n-pv+1);
      i=Math.max(0,Math.min(pages-1,x));
      var slideW=100/pv;
      track.style.transform='translateX(-'+(i*slideW)+'%)';
      dots.forEach(function(d,di){ d.classList.toggle('is-active',di===i); });
      if(prev)prev.disabled=i===0;
      if(next)next.disabled=i>=pages-1;
    }
    if(prev)prev.addEventListener('click',function(){ go(i-1); });
    if(next)next.addEventListener('click',function(){ go(i+1); });
    var x0=null;
    el.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; },{passive:true});
    el.addEventListener('touchend',function(e){ if(x0===null)return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40){ go(dx<0?i+1:i-1); } x0=null; });
    var rt; window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(function(){ buildDots(); go(0); },160); });
    buildDots(); go(0);
  }
  function initAll(scope){ (scope||document).querySelectorAll('[data-ksiazka-oslider]').forEach(initOS); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-opinie"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initReviews(list){
    if(list.dataset.ksReady) return; list.dataset.ksReady='1';
    var section=list.closest('.ksiazka-rw');
    var btn=section?section.querySelector('[data-ksiazka-more]'):null;
    if(!btn) return;
    btn.addEventListener('click',function(){
      list.querySelectorAll('.ksiazka-rw__card.is-extra[hidden]').forEach(function(c){ c.hidden=false; });
      btn.remove();
    });
  }
  function initAll(scope){ (scope||document).querySelectorAll('[data-ksiazka-reviews]').forEach(initReviews); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-podglad"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initV(el){
    if(el.dataset.ksReady) return; el.dataset.ksReady='1';
    var btn=el.querySelector('.ksiazka-pv__play');
    var v=el.querySelector('video');
    if(!btn||!v) return;
    btn.addEventListener('click',function(){
      v.setAttribute('controls','');
      el.classList.add('is-playing');
      var p=v.play(); if(p&&p.catch){ p.catch(function(){}); }
    });
  }
  function initAll(s){ (s||document).querySelectorAll('[data-ksiazka-video]').forEach(initV); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function initGallery(g){
    if(g.dataset.ksReady) return; g.dataset.ksReady='1';
    var slides = g.querySelectorAll('.ksiazka-gal__slide');
    var thumbs = g.querySelectorAll('.ksiazka-gal__thumb');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        var i = t.getAttribute('data-index');
        slides.forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-index')===i); });
        thumbs.forEach(function(x){ var a=x===t; x.classList.toggle('is-active', a); x.setAttribute('aria-selected', a?'true':'false'); });
      });
    });
  }

  function initAcc(a){
    if(a.dataset.ksReady) return; a.dataset.ksReady='1';
    a.querySelectorAll('.ksiazka-acc__head').forEach(function(h){
      h.addEventListener('click', function(){
        var open = h.getAttribute('aria-expanded')==='true';
        h.setAttribute('aria-expanded', open?'false':'true');
      });
    });
  }

  function openDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer){ window.location.href = root() + 'cart'; return; }
    try{
      if(typeof drawer.open === 'function'){ drawer.open(); }
      else { drawer.classList.remove('is-empty'); drawer.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
    }catch(e){ drawer.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
  }

  function refreshDrawer(){
    var wrap = document.getElementById('shopify-section-cart-drawer');
    return fetch(root() + '?section_id=cart-drawer', {headers:{'Accept':'text/html'}})
      .then(function(r){ return r.text(); })
      .then(function(html){ if(wrap){ wrap.innerHTML = html; } })
      .then(function(){
        return fetch(root() + '?section_id=cart-icon-bubble').then(function(r){return r.text();}).then(function(h){
          var bubble = document.getElementById('shopify-section-cart-icon-bubble');
          if(bubble){ bubble.innerHTML = h; }
        }).catch(function(){});
      }).catch(function(){});
  }

  function initAtc(form){
    if(form.dataset.ksReady) return; form.dataset.ksReady='1';
    var btn = form.querySelector('button[type="submit"]');
    var err = form.querySelector('[data-ksiazka-atc-err]');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(err){ err.hidden=true; err.textContent=''; }
      if(btn){ btn.classList.add('is-loading'); btn.disabled=true; }
      fetch(form.getAttribute('action'), {
        method:'POST',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:new FormData(form)
      })
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
      .then(function(res){
        if(!res.ok){ if(err){ err.hidden=false; err.textContent=(res.body&&res.body.description)||'Nie udało się dodać do koszyka.'; } return; }
        return refreshDrawer().then(openDrawer);
      })
      .catch(function(){ if(err){ err.hidden=false; err.textContent='Wystąpił błąd sieci. Spróbuj ponownie.'; } })
      .finally(function(){ if(btn){ btn.classList.remove('is-loading'); btn.disabled=false; } });
    });
  }

  function initAll(scope){
    var s = scope || document;
    s.querySelectorAll('[data-ksiazka-gallery]').forEach(initGallery);
    s.querySelectorAll('[data-ksiazka-acc]').forEach(initAcc);
    s.querySelectorAll('[data-ksiazka-atc]').forEach(initAtc);
  }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["majty-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGallery(root){
    if(root.dataset.majtyGalleryReady) return;
    root.dataset.majtyGalleryReady = '1';
    var slides = root.querySelectorAll('.majty-gallery__slide');
    var thumbs = root.querySelectorAll('.majty-gallery__thumb');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        var i = t.getAttribute('data-index');
        slides.forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-index')===i); });
        thumbs.forEach(function(x){ var a = x===t; x.classList.toggle('is-active', a); x.setAttribute('aria-selected', a?'true':'false'); });
      });
    });
  }

  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function openDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer){ window.location.href = root() + 'cart'; return; }
    try{
      if(typeof drawer.open === 'function'){ drawer.open(); }
      else { drawer.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
    }catch(e){ drawer.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
  }

  function refreshDrawer(){
    var wrap = document.getElementById('shopify-section-cart-drawer');
    return fetch(root() + '?section_id=cart-drawer', {headers:{'Accept':'text/html'}})
      .then(function(r){ return r.text(); })
      .then(function(html){
        if(wrap){ wrap.innerHTML = html; }
        // odśwież licznik koszyka (best-effort)
        return fetch(root() + '?section_id=cart-icon-bubble').then(function(r){return r.text();}).then(function(h){
          var bubble = document.getElementById('shopify-section-cart-icon-bubble');
          if(bubble){ bubble.innerHTML = h; }
        }).catch(function(){});
      }).catch(function(){});
  }

  function initAtc(form){
    if(form.dataset.majtyAtcReady) return;
    form.dataset.majtyAtcReady = '1';
    var btn = form.querySelector('button[type="submit"]');
    var err = form.querySelector('[data-majty-atc-err]');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(err){ err.hidden = true; err.textContent=''; }
      if(btn){ btn.classList.add('is-loading'); }
      var data = new FormData(form);
      fetch(form.getAttribute('action'), {
        method:'POST',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: data
      })
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
      .then(function(res){
        if(!res.ok){
          if(err){ err.hidden=false; err.textContent = (res.body && res.body.description) || 'Nie udało się dodać do koszyka.'; }
          return;
        }
        return refreshDrawer().then(openDrawer);
      })
      .catch(function(){
        if(err){ err.hidden=false; err.textContent='Wystąpił błąd sieci. Spróbuj ponownie.'; }
      })
      .finally(function(){ if(btn){ btn.classList.remove('is-loading'); } });
    });
  }

  function initSizeModal(scope){
    var root = scope || document;
    var modal = root.querySelector('[data-majty-size-modal]');
    if(!modal) return;
    root.querySelectorAll('[data-majty-size-open]').forEach(function(btn){
      if(btn.dataset.majtySizeReady) return; btn.dataset.majtySizeReady='1';
      btn.addEventListener('click', function(){ modal.hidden=false; document.body.classList.add('overflow-hidden'); });
    });
    if(!modal.dataset.majtySizeReady){
      modal.dataset.majtySizeReady='1';
      var closeModal=function(){ modal.hidden=true; document.body.classList.remove('overflow-hidden'); };
      modal.querySelectorAll('[data-majty-size-close]').forEach(function(c){ c.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !modal.hidden) closeModal(); });
    }
  }

  function initAll(scope){
    (scope||document).querySelectorAll('[data-majty-gallery]').forEach(initGallery);
    (scope||document).querySelectorAll('[data-majty-atc]').forEach(initAtc);
    initSizeModal(scope);
  }

  if(document.readyState!=='loading'){ initAll(); }
  else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["majty-science"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.majtyTabsReady) return; root.dataset.majtyTabsReady='1';
    var tabs=root.querySelectorAll('.majty-sci__tab');
    var panels=root.querySelectorAll('.majty-sci__panel');
    tabs.forEach(function(t){ t.addEventListener('click', function(){
      var i=t.getAttribute('data-tab');
      tabs.forEach(function(x){var a=x===t;x.classList.toggle('is-active',a);x.setAttribute('aria-selected',a?'true':'false');});
      panels.forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-panel')===i);});
    }); });
  }
  function all(s){(s||document).querySelectorAll('[data-majty-tabs]').forEach(init);}
  if(document.readyState!=='loading'){all();}else{document.addEventListener('DOMContentLoaded',function(){all();});}
  document.addEventListener('shopify:section:load',function(e){all(e.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
